module.exports = __webpack_public_path__ + "img/idcard-negative.75975dad.jpg";